import { render, staticRenderFns } from "./ForgotPasswordV2.vue?vue&type=template&id=a4e97484"
import script from "./ForgotPasswordV2.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordV2.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordV2.vue?vue&type=style&index=0&id=a4e97484&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports